import { useIssue } from '@gripp/shared-logic';
import {
  BottomComponentBar,
  IssueEdit,
  LoadingIndicator,
  SlideAction,
  useSlideLayout
} from '@gripp/shared-ui';
import { View } from 'react-native';
import { useLocation, useNavigate, useParams } from 'react-router-dom';

export const ActivityEditColumn = ({
  selectedLabels,
  onLabelsChange,
}: {
  selectedLabels?: Array<{ id: string; name: string }>;
  onLabelsChange?: (labels: Array<{ id: string; name: string }>) => void;
}) => {
  const { issueId } = useParams();
  const { issue, isLoading } = useIssue(issueId ?? '');
  const { onSlideChange, toggleThirdPanel } = useSlideLayout();
  const navigate = useNavigate();
  const location = useLocation();

  const onReassignPress = async () => {
    if (location.pathname !== `/activities/${issue.id}/reassign`) {
      await onSlideChange(SlideAction.NEXT);
      navigate(`/activities/${issue.id}/reassign`);
    }
  };

  if (isLoading) {
    return (
      <LoadingIndicator />
    );
  }

  if (!issue) {
    return null;
  }

  return (
    <IssueEdit
      issue={issue}
      issueId={issue.id}
      currentTitle={issue.title}
      workspaceId={issue.workspace?.id}
      currentLabels={issue.labels}
      currentAdjustCreationDate={issue.adjustCreationDate}
      currentCreatedAt={issue.createdAt}
      bottomBar={(props) => 
        <View style={{
          marginHorizontal: 16,
        }}>
          <BottomComponentBar {...props} backButton={null} />
        </View>
      }
      onReassignPress={onReassignPress}
      onLabelSelectorEdit={toggleThirdPanel}
      externalLabels={selectedLabels}
      onLabelsChange={onLabelsChange}
    />
  );
};